import Vue from "vue";
import VueRouter from "vue-router";
import Login from "@/views/Login.vue";
import Dashboard from "@/views/Dashboard.vue";

Vue.use(VueRouter);
export function createRouter() {
  const routes = [
    {
      path: "/",
      name: "home",
      component: Login,
      meta: {
        title: "Login",
      },
    },
    {
      path: "/home",
      name: "homeTest",
      component: () => import("@/views/Home.vue"),
      meta: {
        title: "Login",
      },
    },
    {
      path: "/about",
      name: "about",
      component: () => import("@/views/About.vue"),
    },
    {
      path: "/invite/:invitationId",
      name: "Invitation",
      component: () => import("@/views/Invitation.vue"),
      meta: {
        title: "Invitation",
      },
    },
    {
      path: "/web",
      component: Dashboard,
      children: [
        {
          path: "/",
          name: "dashboard",
          component: () => import("@/views/dashboard/modules/covid/Form.vue"),
          meta: {
            title: Vue.prototype.$language.newCovidForm,
          },
        },
        {
          path: "my-account",
          name: "my-account",
          component: () => import("@/views/dashboard/MyAccount.vue"),
          meta: {
            title: Vue.prototype.$language.myAccount,
          },
        },
        {
          path: "search",
          name: "Search",
          component: () => import("@/views/dashboard/modules/covid/Search.vue"),
          meta: {
            title: Vue.prototype.$language.searchCovidForm,
          },
        },
        {
          path: "view/:id",
          name: "dashboard",
          component: () => import("@/views/dashboard/modules/covid/View.vue"),
          meta: {
            title: Vue.prototype.$language.viewForm,
          },
        },
        {
          path: "general-administrator",
          name: "moduleAdminstrator",
          component: () => import("@/views/dashboard/administrator/General.vue"),
          meta: {
            title: Vue.prototype.$language.administrator,
          },
        },
        {
          path: "super-administrator",
          name: "moduleSuper",
          component: () => import("@/views/dashboard/administrator/SuperAdministration.vue"),
          meta: {
            title: "Super Administration",
          },
        },
        {
          path: "administrator",
          name: "administrator",
          component: () => import("@/views/dashboard/Administrator.vue"),
          meta: {
            title: "Administrator",
          },
        },
        {
          path: "administrator/general",
          name: "administratorGeneral",
          component: () => import("@/views/dashboard/administrator/General.vue"),
          meta: {
            title: "Organization Administrator",
          },
        },
        {
          path: "administrator/super-administration",
          name: "administratorSuper",
          component: () => import("@/views/dashboard/administrator/SuperAdministration.vue"),
          meta: {
            title: "Super Administration",
          },
        },
      ],
      meta: {
        title: "Dashboard",
      },
    },
  ];
  let myObject = {
    basePath: () => {
      var req = new XMLHttpRequest();
      req.open("GET", document.location, false);
      req.send(null);
      return req.getResponseHeader("base-path");
    },
  };

  /* eslint-disable no-console */
  console.log(myObject.basePath());
  /* eslint-enable no-console */
  const router = new VueRouter({
    mode: "history",
    base: myObject.basePath() || "/",
    routes,
  });
  const EventBus = new Vue();

  Vue.prototype.$eventBus = EventBus;
  router.beforeEach((to, from, next) => {
    // This goes through the matched routes from last to first, finding the closest route with a title.
    // eg. if we have /some/deep/nested/route and /some, /deep, and /nested have titles, nested's will be chosen.
    const nearestWithTitle = to.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.title);

    EventBus.$emit("bread-crumb-level1", { title: "", to: "" });

    // Find the nearest route element with meta tags.
    const nearestWithMeta = to.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.metaTags);
    from.matched
      .slice()
      .reverse()
      .find(r => r.meta && r.meta.metaTags);

    // If a route with a title was found, set the document (page) title to that value.
    if (nearestWithTitle) document.title = nearestWithTitle.meta.title + " - PETRONAS COVID Online Form";

    // Remove any stale meta tags from the document using the key attribute we set below.
    Array.from(document.querySelectorAll("[data-vue-router-controlled]")).map(el => el.parentNode.removeChild(el));

    // Skip rendering meta tags if there are none.
    if (!nearestWithMeta) return next();

    // Turn the meta tag definitions into actual elements in the head.
    nearestWithMeta.meta.metaTags
      .map(tagDef => {
        const tag = document.createElement("meta");

        Object.keys(tagDef).forEach(key => {
          tag.setAttribute(key, tagDef[key]);
        });

        // We use this to track which meta tags we create, so we don't interfere with other ones.
        tag.setAttribute("data-vue-router-controlled", "");

        return tag;
      })
      // Add the meta tags to the document head.
      .forEach(tag => document.head.appendChild(tag));

    next();
  });

  return router;
}
